module.exports = __webpack_public_path__ + "img/compass.279c5d5f.svg";